"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var rgbStringfy_1 = tslib_1.__importDefault(require("./rgbStringfy"));
var rgbToHex_1 = tslib_1.__importDefault(require("./rgbToHex"));
/**
 * Transform a RGB Array to another color format
 */
function formatRGB(arrayRGB, format) {
    var responses = {
        rgbString: function () { return rgbStringfy_1.default.apply(void 0, arrayRGB); },
        hex: function () { return rgbToHex_1.default.apply(void 0, arrayRGB); },
        rgbArray: function () { return arrayRGB; }
    };
    return responses[format]();
}
exports.default = formatRGB;
//# sourceMappingURL=formatRGB.js.map